import * as React from "react"

function WarehouseIcon({...props}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17.059 17.062"
      {...props}
    >
      <path
        data-name="Path 79"
        d="M11.6.28H2.461L.329 3.326h13.4z"
        fill="#eaeaea"
      />
      <path
        data-name="Path 80"
        d="M10.686 10.028v2.608a4.265 4.265 0 001.112 2.87H.329V3.326h13.4v5.788z"
        fill="#d3d2d1"
      />
      <path
        data-name="Rectangle 11"
        fill="#9e9e9e"
        d="M5.508 3.326h3.046v2.437H5.508z"
      />
      <path
        data-name="Path 81"
        d="M5.508 3.326h3.046L7.945.28H6.117z"
        fill="#9e9e9e"
      />
      <path
        data-name="Path 82"
        d="M4.594 14.292H2.157a.304.304 0 010-.609h2.437a.304.304 0 010 .609zm0-1.523H2.157a.304.304 0 110-.609h2.437a.304.304 0 110 .609z"
        fill="#3aa3cd"
      />
      <path
        data-name="Path 83"
        d="M16.778 10.028v2.608a4.265 4.265 0 01-3.046 4.094 4.265 4.265 0 01-3.046-4.094v-2.608l3.046-.914z"
        fill="#baff29"
      />
      <path
        data-name="Path 84"
        d="M13.123 14.293a.3.3 0 01-.213-.091l-.916-.914a.304.304 0 01.43-.43l.7.7 1.919-1.916a.304.304 0 01.43.43L13.339 14.2a.3.3 0 01-.216.093zm.585-10.637H.304a.3.3 0 01-.25-.469L2.187.14a.3.3 0 01.25-.14h9.139a.3.3 0 01.25.131l2.132 3.046a.307.307 0 01-.25.478zM.894 3.046h12.229L11.417.609H2.583z"
        fill="#542020"
      />
      <path
        data-name="Path 85"
        d="M8.53 6.092H5.479a.3.3 0 01-.3-.3V3.346a.3.3 0 01.3-.3h3.046a.3.3 0 01.3.3v2.437a.3.3 0 01-.295.309zm-2.742-.609h2.437V3.655H5.788z"
        fill="#542020"
      />
      <path
        data-name="Path 86"
        d="M8.529 3.655H5.483a.316.316 0 01-.3-.366L5.789.244a.3.3 0 01.3-.244h1.828a.3.3 0 01.3.244l.609 3.046a.307.307 0 01-.3.366zm-2.675-.609h2.3L7.667.609H6.342z"
        fill="#542020"
      />
      <path
        data-name="Path 87"
        d="M4.57 14.317H2.128a.304.304 0 110-.609h2.437a.304.304 0 110 .609zm0-1.523H2.128a.304.304 0 110-.609h2.437a.304.304 0 110 .609z"
        fill="#baff29"
      />
      <path
        data-name="Path 88"
        d="M11.774 15.84H.3a.3.3 0 01-.3-.3V3.346a.3.3 0 01.3-.3h13.4a.3.3 0 01.3.3v5.788a.3.3 0 01-.216.3l-2.83.835v2.382A3.96 3.96 0 0012 15.331a.3.3 0 01-.225.509zM.609 15.231h10.537a4.569 4.569 0 01-.789-2.571v-2.608a.3.3 0 01.216-.3l2.83-.835V3.655H.609z"
        fill="#542020"
      />
      <path
        data-name="Path 89"
        d="M13.708 17.06a.3.3 0 01-.088 0 4.569 4.569 0 01-3.262-4.4v-2.608a.3.3 0 01.216-.3l3.046-.914a.347.347 0 01.177 0l3.046.914a.3.3 0 01.216.3v2.608a4.569 4.569 0 01-3.263 4.4.3.3 0 01-.088 0zm-2.742-6.781v2.381a3.96 3.96 0 002.742 3.789 3.942 3.942 0 002.742-3.774v-2.4l-2.742-.835z"
        fill="#542020"
      />
      <path
        data-name="Path 90"
        d="M13.099 14.317a.3.3 0 01-.216-.089l-.914-.914a.306.306 0 01.433-.433l.7.7 1.916-1.919a.306.306 0 01.433.433l-2.136 2.133a.3.3 0 01-.216.089z"
        fill="#1a1b41"
      />
    </svg>
  )
}

export default WarehouseIcon